export enum RecoverPasswordStep {
    USER_FORM = "user_form",
    EMAIL_SENT = "email_sent",
    ERROR = "internal_error"
}